// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__0Gy7d","element":"style_element__CfuAa","title":"style_title__jywrd","button":"style_button___Qj1K"};